/**
 * Re-exporta Link e Outlet do TanStack Router com tipagem compatível
 * com @types/react 18 (evita conflito quando há duas versões de @types/react no monorepo).
 */
import type React from 'react';
import { Link as RouterLink, Outlet as RouterOutlet } from '@tanstack/react-router';

type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  to: string;
  params?: Record<string, string>;
  search?: unknown;
  children?: React.ReactNode;
};

export const Link = RouterLink as unknown as React.ComponentType<LinkProps>;
export const Outlet = RouterOutlet as unknown as React.ComponentType<Record<string, unknown>>;
